module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_15.c4aa8c61.jpg";